import { useEffect, useState } from "react";
import { ArrowRightIcon } from "lucide-react";
import { CTA_URL } from "./constants";
import { Countdown } from "./Countdown";
import { trackMetaEvent } from "./MetaPixel";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById("hero-cta-anchor");
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      // Show once the hero CTA has scrolled out of view (above the viewport)
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  const track = () => {
    trackMetaEvent("InitiateCheckout");
  };
  return <div className={`fixed inset-x-0 bottom-0 z-50 transition-all duration-300 ${visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-full opacity-0"}`} data-id="element-104" data-mp="19785q3q3qbdq">
      <div className="border-t border-white/10 bg-[#0f2547]/95 px-3 py-2.5 backdrop-blur-md shadow-[0_-8px_30px_-8px_rgba(0,0,0,0.5)]" data-id="element-105" data-mp="2b2yx9kp0y3jg">
        <div className="mx-auto flex max-w-lg items-center gap-3" data-id="element-106" data-mp="21cnj75bmmdyu">
          <div className="hidden flex-col leading-none xs:flex" data-id="element-107" data-mp="21cdtliuhu8to">
            <span className="text-[10px] font-600 uppercase tracking-wider text-white/50" data-id="element-108" data-mp="26ap31sgvmhbd">
              Oferta termina en
            </span>
            <Countdown compact data-id="element-109" data-mp="1rgklcbnt51hp" />
          </div>
          <a href={CTA_URL} onClick={track} className="group flex flex-1 items-center justify-center gap-2 rounded-xl bg-[#f5a623] px-4 py-3 font-head text-sm font-800 uppercase tracking-wide text-[#0a1a34] shadow-lg transition-all hover:bg-[#ffb733] active:scale-[0.98] sm:text-base" data-id="element-110" data-mp="1wdt1y7tb4xgu">
            Quiero el Sistema
            <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-111" data-mp="3cpyapmqafyrk" />
          </a>
        </div>
      </div>
    </div>;
}